import React, { useEffect, useState } from 'react';
import { Modal, ModalHeader, ModalBody } from 'reactstrap';

const BaseModalXXL = ({ isOpen, onClose, title, children, loading, fullscreen = false, container, headerAction, className = '' }) => {
    const backdropStyle = 'static';
    const [isResponsiveViewport, setIsResponsiveViewport] = useState(
        () => typeof window !== 'undefined' && window.matchMedia('(max-width: 767px)').matches
    );

    useEffect(() => {
        const mediaQuery = window.matchMedia('(max-width: 767px)');
        const syncViewport = () => setIsResponsiveViewport(mediaQuery.matches);
        syncViewport();
        mediaQuery.addEventListener('change', syncViewport);
        return () => mediaQuery.removeEventListener('change', syncViewport);
    }, []);

    // Igual que el hub de Videos IA: los BaseModalXXL se montan como
    // fullscreen en móvil. Los estilos globales los conservan como bottom
    // sheet, pero Reactstrap elimina sus márgenes laterales nativos.
    const shouldUseFullscreen = fullscreen || isResponsiveViewport;
    const customModalStyle = shouldUseFullscreen ? undefined : { maxWidth: '90%' };

    return (
        <Modal
            isOpen={isOpen}
            toggle={onClose}
            backdrop={backdropStyle}
            keyboard={false}
            zIndex={9999}
            centered={!shouldUseFullscreen}
            fullscreen={shouldUseFullscreen}
            container={container}
            className={className}
            style={customModalStyle}  // Aplica el estilo inline aquí
        >
            <ModalHeader toggle={onClose}>
                <div className="base-modal-xxl-header-content">
                    <span>{title}</span>
                    {headerAction}
                </div>
            </ModalHeader>
            <ModalBody>
                {children}
            </ModalBody>
        </Modal>
    );
};

export default BaseModalXXL;
